import React from "react";
import store from './Stores/SurveyStore'
import userStore from './Stores/UserStore'
import { BeatLoader } from 'react-spinners';
import { NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import { observer } from "mobx-react";
import SurveySection from '../components/SurveySection';
import SurveyElement from '../components/SurveyElement';
import { validateSurveyCrtl, submitSurveyCtrl } from '../control';

import { css } from '@emotion/core';
import {SurveyTypeURL} from "../Enums/constants";
const ErrorSummary = observer((props) => {
    const clickValidate = () => {
        validateSurveyCrtl();
    }

    const clickSubmit = () => {
        submitSurveyCtrl();
    }

    const override = css`
        display: block;
        margin: 0 auto;
        border-color: red;
    `;

    const planId = store.currentSurvey.SystemId;
    const shouldShowSubmit = userStore.isPlanAdministrator(planId)

    let contactPersonMessage;
    switch (store.surveyTypeUrl) {
        case SurveyTypeURL.PABS_UK:
            contactPersonMessage = "John Simmonds at johns@explorecem.com or +44 203 887 9289";
            break;
        default:
            contactPersonMessage = "Yvette van Velsen at Yvette@explorecem.com";
            break;
    }
    
    let submitSection;
    if(shouldShowSubmit)
        submitSection =
            <>
                {store.currentSurvey.IsReadOnly &&
                    <div className="surveyRow">
                        Thank you for your submission. 
                        We will contact you in the next few days if there are any follow-up questions. 
                        <br />
                        In the meanwhile, if you have any questions, please contact {contactPersonMessage}
                    </div>
                }
                <div className="center">
                    <NavLink onClick={clickSubmit} className="btn btn-unlock" disabled={store.currentSurvey.IsReadOnly}>
                        Submit Survey
                    </NavLink>
                </div>
            </>
    else
        submitSection =
            <div className="center">
                Only the main survey preparer can submit the survey.
            </div>
    
    return (
        <React.Fragment>
            <SurveySection labelText="Step 1 - Validate">
                <SurveyElement
                    labelText="To help us ensure the correctness of your data, click the validate button below and then review the messages at the top of each page."/>

                <div className="center">
                    <button type="button" className="btn btn-unlock" disabled={store.currentSurvey.IsValidated}
                            onClick={clickValidate}>Validate Survey
                    </button>
                </div>

                {!store.loadingErrorSummaryDone &&
                    <div className='sweet-loading'>
                        <BeatLoader
                            css={override}
                            sizeUnit={"px"}
                            size={25}
                            color={'#6aaaad'}
                            loading={!store.loadingErrorSummaryDone}
                        />
                    </div>
                }
                
                <div className="surveyRow">
                    {store.loadingErrorSummaryDone && store.warningSummary.length > 0 &&
                        <div className="errors-desc">
                            <h5 style={{color: '#d1b654'}}>Unusual Items Found</h5>
                            <span>The following tabs have unusual data items: </span>

                            {(store.warningSummary).map((page, i) => (
                                <span> 
                                    <NavLink tag={Link} to={store.surveyTypeUrl + page} className="plain-link"> 
                                        {page.replace('_', ' ')}
                                    </NavLink>
                                    {i !== store.warningSummary.length - 1 && <span>, </span>}
                                </span>
                            ))
                            }. The items are highlighted in yellow. Please check off each item, and if possible, explain
                            why the data is unusual in the 'Add explanation' field that appears when you click the link.
                            After checking all items, click submit below.
                            <br/>
                            <br/>

                        </div>
                    }
                </div>
                <div className="surveyRow">
                    {store.loadingErrorSummaryDone && store.errorSummary.length > 0 &&
                        <div className="errors-desc">
                            <h5 style={{color: '#95212c'}}>Errors Found</h5>
                            <span>The following tabs have problems that must be fixed before you can submit your data: </span>
                            {(store.errorSummary).map((page, i) => (
                                <span> 
                                    <NavLink tag={Link} to={store.surveyTypeUrl + page} className="plain-link">
                                        {page.replace('_', ' ')}
                                    </NavLink>
                                    {i !== store.errorSummary.length - 1 && <span>, </span>}
                                </span>
                            ))
                            }. The problems are highlighted in pink. Point the cursor at each highlighted field to see
                            specific error messages. After fixing all the problems highlighted in pink (and after
                            checking the unusual data items highlighted in yellow), please submit your survey by
                            clicking the submit button below.
                        </div>
                    }
                </div>
            </SurveySection>

            <SurveySection labelText="Step 2 - Submit Your Data">
                {submitSection}
            </SurveySection>
            {props.children}
        </React.Fragment>
    );
});

export default ErrorSummary;